import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { QuotesService } from '../../services/quotations.services';
import { SetQuotationsLoader } from '../../store/quotations.actions';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-quote-document',
  templateUrl: './quote-document.component.html',
  styleUrls: ['./quote-document.component.scss']
})
export class QuoteDocumentComponent implements OnInit {
  pdfUrl: SafeResourceUrl | null = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    private dialogRef: MatDialogRef<QuoteDocumentComponent>,
    private services: QuotesService,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.loadPdf();
  }

  loadPdf(): void {
    this.store.dispatch(SetQuotationsLoader({ isLoading: true }));
    
    this.services.getPdfQuotation(this.data).subscribe({
      next: (res) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      },
      error: (err) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        console.error('Error loading PDF:', err);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
